import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CommonModule } from '@angular/common';

@Component({
	standalone: true,
	selector: 'lmc-loading-dialog',
	templateUrl: 'lmc-loading-dialog.component.html',
	styleUrls: ['lmc-loading-dialog.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [CommonModule, MatDialogModule, MatProgressSpinnerModule],
})
export class LmcLoadingDialogComponent {
	readonly data = inject<LmcLoadingDialogData>(MAT_DIALOG_DATA);
}

export interface LmcLoadingDialogData {
	message?: string;
}